import { createEvent, sample } from 'effector'
import { epgRegionsModel } from '~/entities/epg/regions'
import { epgRegionsFeature } from '~/features/epg/regions'
import { selectEpgRegionModel } from '~/features/epg/regions/select'
import { preferencesFeatureModel } from '~/features/preferences'
import { epgCategoriesWidgetModel } from './categories'
import { epgChannelsWidgetModel } from './channels'
import { epgDatesWidgetModel } from './dates'
import { epgInfoWidgetModel } from './info'
import { epgPlayerWidgetModel } from './player'
import { epgProgramsWidgetModel } from './programs'
import { epgRegionsWidgetModel } from './regions'
import { epgSidebarWidgetModel } from './sidebar'
import { epgSkeletonWidgetModel } from './skeleton'

export const resetEpg = createEvent()

// same cleanup as `resetEpg`, but the selected category tab survives.
// used only by the region change on the EPG board: My List is not region-scoped, so a region change
// must not drop the user from that tab onto All
export const resetEpgKeepingCategory = createEvent()

// this could involve full cleanup
sample({
  clock: [resetEpg, resetEpgKeepingCategory],
  target: [
    epgSkeletonWidgetModel.reset,
    epgChannelsWidgetModel.reset,
    epgDatesWidgetModel.reset,
    epgPlayerWidgetModel.reset,
    epgProgramsWidgetModel.reset,
    epgSidebarWidgetModel.reset,
    epgInfoWidgetModel.reset,
  ],
})

sample({
  clock: resetEpg,
  target: epgCategoriesWidgetModel.reset,
})

sample({
  clock: resetEpgKeepingCategory,
  target: epgCategoriesWidgetModel.resetKeepingSelectedCategory,
})

// open popup if region from url is not exist in the list of available regions,
// reset region storage, reset epg
sample({
  clock: epgRegionsWidgetModel.checkIdFromUrl,
  source: {
    regions: epgRegionsModel.$regionsAlphabeticallySorted,
    primaryRegion: preferencesFeatureModel.$preference,
  },
  filter: ({ regions, primaryRegion }, id) => {
    // in case when in url wrong epg region id and user open the app for the first time (there is no primaryRegion)
    // should not be opened popup and reset region storage
    if (!primaryRegion) return false

    // if there are no regions, the popup is not opened and no need to reset region storage
    if (regions?.length === 0) return false

    return !regions?.find((region) => region.id === id)
  },
  target: [
    selectEpgRegionModel.resetRegionStorage,
    epgRegionsFeature.checkOpenPopup,
    resetEpg,
  ],
})
